import React, { useEffect, useState } from "react";
import axios from "axios";
import API_URL from "../config";
import Swal from "sweetalert2";

const GestionarModoSeguridad = () => {
  const [modo, setModo] = useState(null);
  const [cargando, setCargando] = useState(false);

  const cargarModo = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_URL}/api/modo-seguridad/citas`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setModo(res.data.modo);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    cargarModo();
  }, []);

  const cambiarModo = async (nuevoModo) => {
    const nombre = nuevoModo === "cloudflare" ? "Cloudflare" : "Nativo Servidor";
    const confirm = await Swal.fire({
      title: `¿Cambiar a modo ${nombre}?`,
      text: "Esto recarga la configuración del servidor para citas.dsm.edu.ni.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, cambiar",
      cancelButtonText: "Cancelar",
    });
    if (!confirm.isConfirmed) return;

    setCargando(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API_URL}/api/modo-seguridad/citas/${nuevoModo}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setModo(nuevoModo);
      Swal.fire("Listo", "El modo se cambió correctamente.", "success");
    } catch (err) {
      Swal.fire("Error", err.response?.data?.error || "No se pudo cambiar el modo", "error");
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8 }}>🔒 Modo de Seguridad</h2>
      <p style={{ color: "#64748b", marginBottom: 20 }}>
        Controla cómo llega el tráfico a citas.dsm.edu.ni: a través del proxy de Cloudflare
        (naranja), o directo al servidor (gris/DNS only).
      </p>

      <div style={{ marginBottom: 16, fontWeight: 600 }}>
        Modo actual:{" "}
        {modo === "cloudflare"
          ? "🔵 Cloudflare"
          : modo === "nativo"
          ? "🖥️ Nativo Servidor"
          : "Cargando..."}
      </div>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
        <button
          disabled={cargando || modo === "cloudflare"}
          onClick={() => cambiarModo("cloudflare")}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: "none",
            background: modo === "cloudflare" ? "#93c5fd" : "#2563eb",
            color: "#fff",
            fontWeight: 600,
            cursor: modo === "cloudflare" ? "default" : "pointer",
          }}
        >
          🔵 Modo Cloudflare
        </button>

        <button
          disabled={cargando || modo === "nativo"}
          onClick={() => cambiarModo("nativo")}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: "none",
            background: modo === "nativo" ? "#86efac" : "#16a34a",
            color: "#fff",
            fontWeight: 600,
            cursor: modo === "nativo" ? "default" : "pointer",
          }}
        >
          🖥️ Modo Nativo Servidor
        </button>
      </div>

      <p style={{ color: "#94a3b8", fontSize: 13, marginTop: 20 }}>
        Usá "Cloudflare" cuando el registro DNS de citas esté en naranja (proxied) en Cloudflare.
        Usá "Nativo Servidor" cuando esté en gris (DNS only).
      </p>
    </div>
  );
};

export default GestionarModoSeguridad;
